import { z } from "zod";

const REG_PHONE_10_DIGITS = /^0\d{9}$/;
const REG_PHONE_11_DIGITS = /^0\d{10}$/;

type ValidatorSchemaType = {
  username: z.ZodString;
  phone: {
    [key: number]: z.ZodString;
  };
  otp: z.ZodString;
  legalName: z.ZodString;
  firstName: z.ZodString;
  lastName: z.ZodString;
  payment: {
    eWallet: {
      accountNo: {
        [key: number]: z.ZodString;
      };
      accountType: z.ZodString;
      isDefault: z.ZodOptional<z.ZodBoolean>;
    };
    bank: {
      bankKey: z.ZodString;
      accountNo: z.ZodString;
    };
  };
  loginPassword: z.ZodString;
  loginPin: z.ZodString;
  registerPassword: z.ZodString;
};

export const ValidatorSchema: ValidatorSchemaType = {
  username: z
    .string()
    .min(4, "4-13 alphanumeric without special character.")
    .max(13, "4-13 alphanumeric without special character.")
    .regex(/^\w+$/, "only letters, numbers, and underscores (_) are allowed."),
  loginPassword: z.string().min(8, "at least 8 characters with letters & numbers"),
  loginPin: z.string().min(4, "PIN length is invalid"),
  registerPassword: z
    .string()
    .min(8, "at least 8 characters with letters & numbers")
    .regex(/^(?=.*[A-Za-z])(?=.*\d).+$/, "at least 8 characters with letters & numbers")
    .regex(/^\S+$/, "spaces are not allowed"),
  phone: {
    "10": z
      .string()
      .regex(/^0/, "phone number should start with 0")
      .regex(REG_PHONE_10_DIGITS, "Phone number must be 10 digits"),
    "11": z
      .string()
      .regex(/^0/, "enter a 11-digit number starting with 0")
      .regex(REG_PHONE_11_DIGITS, "enter a 11-digit number starting with 0"),
  },
  otp: z.string().min(1, "otp is required. click on get code"),
  legalName: z.string().min(1, "required"),
  firstName: z
    .string({
      required_error: "First name is required",
    })
    .min(1, "First name is required"),
  lastName: z
    .string({
      required_error: "Last name is required",
    })
    .min(1, "Last name is required"),
  payment: {
    eWallet: {
      accountNo: {
        "10": z
          .string({
            required_error: "required",
          })
          .min(1, "required")
          .regex(/^0/, "enter a 10-digit number starting with 0")
          .regex(REG_PHONE_10_DIGITS, "enter a 10-digit number starting with 0"),
        "11": z
          .string({
            required_error: "required",
          })
          .min(1, "required")
          .regex(/^0/, "enter a 11-digit number starting with 0")
          .regex(REG_PHONE_11_DIGITS, "enter a 11-digit number starting with 0"),
      },
      accountType: z
        .string({
          required_error: "required",
        })
        .min(1, "required"),
      isDefault: z.boolean().optional(),
    },
    bank: {
      bankKey: z
        .string({
          required_error: "Bank name is required",
        })
        .min(1, "Bank name is required"),
      accountNo: z
        .string({
          required_error: "Account number is required",
        })
        .min(1, "Account number is required")
        .regex(/^\d+$/, "account number must be digits only")
        .regex(/^\d{5,34}$/, "account number must be 5-34 digits"),
    },
  },
};
